import useDebounce from "hooks/useDebounce";
import { FC, useEffect} from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { setSearch } from "toolkit/steps/stepFive/stepFive.slice";
import { getDocuments } from "toolkit/steps/stepFive/viewDocuments/viewDocuments.thunks";
import Body from "./Body";
import Head from "./Head";
import styles from "./Table.module.sass";

const Table: FC = () => {
	const dispatch = useAppDispatch();

	const search = useAppSelector((state) => state.stepFive.search);

	const debouncedSearch = useDebounce(search, 400);

	const params = useParams();

	useEffect(() => {
		if (params.organizationId) dispatch(getDocuments(Number(params.organizationId)));
		//eslint-disable-next-line
	}, [debouncedSearch]);

	useEffect(() => {
		return () => {
			dispatch(setSearch(""));
		};
		//eslint-disable-next-line
	}, []);

	return (
		<div className={styles.table}>
			<Head />
			<Body />
		</div>
	);
};

export default Table;
